const toolTipData = [
  {
    id: "date",
    text: "Select Date."
  },
  {
    id: "locationName",
    text: "Select Location to Get the Users Attendance."
  },
  {
    id: "Filter",
    text: "Search by User-id, Aadhar-Card, Full Nam."
  }
];

const tableHeaderData = [
  {
    label: "Full Name",
    place: "left",
    type: "workerFullName",
    toolTipText: "Click for Full Name Sorting"
  },
  {
    label: "Employee Id",
    place: "left",
    type: "workerId",
    toolTipText: "Click for E-ID Sorting"
  }
];

const selectOptions = [
  {
    label: "Location",
    value: "Location"
  },
  {
    label: "Department",
    value: "workerDepartment"
  },
  {
    label: "Designation",
    value: "workerDesignation"
  },
  {
    label: "Aadhar Card Number",
    value: "workerAadharCardNumber"
  },
  {
    label: "Employee Type",
    value: "workerType"
  },
  {
    label: "Detection Image",
    value: "detectionImages"
  }
];

export { toolTipData, tableHeaderData, selectOptions };
